import React, { Fragment } from "react";
import { v4 as uuidv4 } from "uuid";
import * as jsPDF from "jspdf";

import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  FormGroup,
  Button,
  Input,
  InputGroup,
  Table,
  Form
} from "reactstrap";

const DEFAULT_SELECT_OPTIONS = [
  { value: "", label: "Elija tipo de acto", isDisabled: true },
  { value: "1", label: "Compra Venta" },
  { value: "2", label: "Compra Venta e hipoteca con particulares" },
  { value: "3", label: "Compra Venta e Hipoteca con entidades financieras" },
  { value: "4", label: "Hipoteca" },
  { value: "5", label: "Cancelacion de hipoteca con particulares" },
  { value: "6", label: "Cancelacion de hipoteca con entidades financieras" },
  { value: "7", label: "Matrimonio Civil en la notaria" },
  { value: "8", label: "Matrimonio Civil a domicilio" },
  { value: "9", label: "Sucesiones" },
  { value: "10", label: "Liquidacion de sociedad conyugal" }
];

const DEFAULT_ACTOS_MAP = {
  "1": "5d7efbd8-65b1-4edb-ae78-c120c38e7a29",
  "2": "529e1559-d146-4456-9670-7b412f2b343c",
  "3": "529e1559-d146-4456-9670-7b412f2b343c",
  "4": "9773adf4-796f-455b-9416-7fa98f287715",
  "5": "287302b9-6780-4709-8f2f-2d2edaf4fe31",
  "6": "287302b9-6780-4709-8f2f-2d2edaf4fe31",
  "7": "15b4aa9a-e168-4571-94cb-6cc3743348c5",
  "8": "c789b97d-9940-46f4-921b-9d3711bd84a3",
  "9": "b8792e4e-3ad2-4df0-afde-ab75b735ec31",
  "10": "48036ace-a20d-4d02-bdfc-e62bebb2748e",
  "hipoteca_particulares": "9773adf4-796f-455b-9416-7fa98f287715",
  "hipoteca_entidades": "9756339f-792e-4941-a91b-c80c0dfb8f51"
};

const CotizadorCore = ({
  notaria = {},
  serviciosIniciales = [],
  onCotizar,
  logoSrc,
  selectOptions = DEFAULT_SELECT_OPTIONS,
  actosMap = DEFAULT_ACTOS_MAP,
  initialRetencion = true,
  title = "COTIZADOR"
}) => {
  const [tipoEscritura, setTipoEscritura] = React.useState("");
  const [nombreActo, setNombreActo] = React.useState("");
  const [valorCuantia, setValorCuantia] = React.useState("");
  const [valorHipoteca, setValorHipoteca] = React.useState("");
  const [, setTotalDerechos] = React.useState(0);
  const [tCotizacion, setCotizacion] = React.useState(0);
  const [tFondo, setFondo] = React.useState(0);
  const [tSuper, setSuper] = React.useState(0);
  const [tRete, setRete] = React.useState(0);
  const [tIva, setIva] = React.useState(0);
  const [porcentajeIva, setPorcentajeIva] = React.useState(0);
  const [showHipoteca, setHipoteca] = React.useState(false);
  const [showCuantia, setCuantia] = React.useState(false);
  const [showDerechos, setDerechos] = React.useState(false);
  const [showStatico, setStatico] = React.useState(false);
  const [servicios, setServicios] = React.useState(Array.isArray(serviciosIniciales) ? serviciosIniciales : []);
  const [checkedRete, setCheckedRete] = React.useState(initialRetencion);
  const [actosDerechos, setActosDerechos] = React.useState([]);

  const serviceDisabled = [1];

  React.useEffect(() => {
    setServicios(Array.isArray(serviciosIniciales) ? serviciosIniciales : []);
  }, [serviciosIniciales]);

  const getNumeroSeguro = (valor) => {
    const numero = Number(valor);
    return Number.isFinite(numero) ? numero : 0;
  };

  const normalizarTexto = (valor = "") =>
    valor
      .toString()
      .trim()
      .toLowerCase();

  const obtenerValor = (origen, campos = []) => {
    for (let i = 0; i < campos.length; i += 1) {
      const valor = origen?.[campos[i]];
      if (valor !== undefined && valor !== null) {
        return valor;
      }
    }
    return undefined;
  };

  const recalcularTotalesFrontend = (serviciosActualizados, aplicaRetencion = checkedRete) => {
    let subtotalServicios;

    if (actosDerechos.length > 0) {
      subtotalServicios = serviciosActualizados
        .filter((s) => Number(s.id) !== 1)
        .reduce(
          (acum, servicio) =>
            acum + getNumeroSeguro(servicio.valor_unit) * getNumeroSeguro(servicio.cant_predet),
          0
        );
      subtotalServicios += actosDerechos.reduce(
        (acum, d) => acum + getNumeroSeguro(d.valor_unit) * getNumeroSeguro(d.cantidad),
        0
      );
    } else {
      subtotalServicios = serviciosActualizados.reduce(
        (acum, servicio) =>
          acum + getNumeroSeguro(servicio.valor_unit) * getNumeroSeguro(servicio.cant_predet),
        0
      );
    }

    const ivaCalculado = Math.round(subtotalServicios * (getNumeroSeguro(porcentajeIva) / 100));
    const totalCalculado =
      subtotalServicios +
      ivaCalculado +
      getNumeroSeguro(tFondo) +
      getNumeroSeguro(tSuper) +
      (aplicaRetencion ? getNumeroSeguro(tRete) : 0);

    setIva(ivaCalculado);
    setCotizacion(totalCalculado);
  };

  const updateCantidad = (id, value) => {
    const nuevaCantidad = Number(value);
    const cantidad = Number.isFinite(nuevaCantidad) ? nuevaCantidad : 0;
    const tempService = servicios.map((item) => {
      if (item.id.toString() !== id.toString()) {
        return item;
      }

      return {
        ...item,
        cant_predet: cantidad
      };
    });
    setServicios(tempService);

    if (showDerechos && showStatico && !serviceDisabled.includes(Number(id))) {
      recalcularTotalesFrontend(tempService, checkedRete);
    }
  };

  const aplicarRespuestaCotizacion = (respuestaApi) => {
    const envelope = respuestaApi?.data || {};
    const payload = envelope?.data || envelope;
    const actosRespuesta = Array.isArray(payload?.actos) ? payload.actos : [];
    const actoCotizado = actosRespuesta[0] || {};
    const resumenActo = actoCotizado?.resumen || {};
    const resumenGeneral = payload?.resumen_general || {};
    const detalleActo = Array.isArray(actoCotizado?.detalle)
      ? actoCotizado.detalle
      : [];

    const iva = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["iva"]) ||
      obtenerValor(resumenActo, ["iva"]) ||
      obtenerValor(actoCotizado, ["iva", "total_iva"])
    );
    const superRegistro = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["super"]) ||
      obtenerValor(actoCotizado, ["super", "super_registro", "total_super"])
    );
    const fondo = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["fondo"]) ||
      obtenerValor(actoCotizado, ["fondo", "fondo_registro", "total_fondo"])
    );
    const retencion = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["retencion"]) ||
      obtenerValor(resumenActo, ["retencion"]) ||
      obtenerValor(actoCotizado, ["retencion", "retefuente", "total_retencion"])
    );

    const derechosDetalle =
      detalleActo.find((item) => normalizarTexto(item?.tarifa_tipo) === "derecho_notarial") ||
      detalleActo.find((item) => normalizarTexto(item?.concepto) === "derechos notariales");

    const derechosCantidad = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["cantidad"])) || 1;
    const derechosTotal = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["total"]));
    const derechosUnitario = getNumeroSeguro(
      obtenerValor(derechosDetalle || {}, ["valor_unitario", "valor_unit", "valor"])
    );

    const derechos =
      derechosUnitario ||
      (derechosTotal > 0 ? Math.round(derechosTotal / derechosCantidad) : 0) ||
      getNumeroSeguro(
        obtenerValor(actoCotizado, ["derechos", "derechos_notariales", "total_derechos"])
      );

    const total = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["total"]) ||
      obtenerValor(resumenActo, ["total"]) ||
      obtenerValor(actoCotizado, ["total", "total_cotizacion", "gran_total"])
    );

    const subtotalServicios = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["subtotal_servicios"]) ||
      obtenerValor(resumenActo, ["subtotal_servicios"])
    );
    const ivaDetalle = detalleActo.find((item) => normalizarTexto(item?.concepto) === "iva");
    const ivaPorcentajeRespuesta = getNumeroSeguro(obtenerValor(ivaDetalle || {}, ["iva"]));
    const ivaPorcentajeCalculado = subtotalServicios > 0 ? (iva * 100) / subtotalServicios : 0;
    setPorcentajeIva(ivaPorcentajeRespuesta || ivaPorcentajeCalculado);

    const esMultiActo = actosRespuesta.length > 1;
    if (esMultiActo) {
      const derechosMultiActo = actosRespuesta.map((acto, idx) => {
        const detalleA = Array.isArray(acto?.detalle) ? acto.detalle : [];
        const derechosD =
          detalleA.find((item) => normalizarTexto(item?.tarifa_tipo) === "derecho_notarial") ||
          detalleA.find((item) => normalizarTexto(item?.concepto) === "derechos notariales");
        const cant = getNumeroSeguro(obtenerValor(derechosD || {}, ["cantidad"])) || 1;
        const tot = getNumeroSeguro(obtenerValor(derechosD || {}, ["total"]));
        const unit = getNumeroSeguro(obtenerValor(derechosD || {}, ["valor_unitario", "valor_unit", "valor"]));
        const der = unit || (tot > 0 ? Math.round(tot / cant) : 0) ||
          getNumeroSeguro(obtenerValor(acto, ["derechos", "derechos_notariales", "total_derechos"]));
        const nombreA = obtenerValor(acto?.acto || {}, ["nombre"]) || `Acto ${idx + 1}`;
        return { nombre: `Derechos Notariales - ${nombreA}`, cantidad: cant, valor_unit: der };
      });
      setActosDerechos(derechosMultiActo);
    } else {
      setActosDerechos([]);
      const nombreActoRespuesta = obtenerValor(actoCotizado?.acto || {}, ["nombre"]);
      if (nombreActoRespuesta) {
        setNombreActo(nombreActoRespuesta);
      }
    }

    setIva(iva);
    setSuper(superRegistro);
    setFondo(fondo);
    setRete(retencion);
    setTotalDerechos(derechos);
    setCotizacion(total);

    const serviciosRespuesta = detalleActo.filter(
      (item) => normalizarTexto(item?.tarifa_tipo) === "servicio_adicional"
    );

    const serviciosActualizados = servicios.map((servicio) => {
      if (Number(servicio.id) === 1) {
        if (esMultiActo) {
          return { ...servicio, cant_predet: 0, valor_unit: 0 };
        }
        return {
          ...servicio,
          cant_predet: derechosCantidad,
          valor_unit: derechos
        };
      }

      if (Array.isArray(serviciosRespuesta) && serviciosRespuesta.length > 0) {
        const encontrado = serviciosRespuesta.find(
          (item) =>
            (item?.id && String(item.id) === String(servicio.id)) ||
            normalizarTexto(item?.concepto) === normalizarTexto(servicio?.servicio_name)
        );

        if (!encontrado) {
          return servicio;
        }

        return {
          ...servicio,
          cant_predet: getNumeroSeguro(
            obtenerValor(encontrado, ["cantidad", "cant_predet", "cant"])
          ),
          valor_unit: getNumeroSeguro(
            obtenerValor(encontrado, ["valor_unitario", "valor_unit", "valor"])
          )
        };
      }

      return servicio;
    });
    setServicios(serviciosActualizados);

    setStatico(true);
  };

  const selectTipoEscritura = (event) => {
    const value = event.target.value;
    if (!value) {
      return;
    }

    const option = selectOptions.find((opt) => opt.value === value);
    setTipoEscritura(value);
    setNombreActo(option ? option.label.trim() : "");
    setValorCuantia("");
    setValorHipoteca("");
    setCotizacion(0);
    setIva(0);
    setSuper(0);
    setFondo(0);
    setRete(0);
    setTotalDerechos(0);
    setActosDerechos([]);
    setStatico(false);
    // Recargar cantidades predeterminadas de servicios
    setServicios(Array.isArray(serviciosIniciales) ? serviciosIniciales : []);

    switch (value) {
      case "1":
        setHipoteca(false);
        setCuantia(true);
        break;
      case "2":
      case "3":
        setHipoteca(true);
        setCuantia(true);
        break;
      case "4":
      case "5":
        setHipoteca(true);
        setCuantia(false);
        break;
      case "6":
      case "7":
      case "8":
        setHipoteca(false);
        setCuantia(false);
        break;
      case "9":
      case "10":
        setHipoteca(false);
        setCuantia(true);
        break;
      default:
        setHipoteca(false);
        setCuantia(false);
    }

    setDerechos(true);
  };

  const checkedRetencion = (val) => {
    setCheckedRete(val);
    if (showDerechos && showStatico) {
      recalcularTotalesFrontend(servicios, val);
    }
  };

  const cotizar = async (retencionActiva = checkedRete, serviciosParaCotizar = servicios) => {
    if (!tipoEscritura || typeof onCotizar !== "function") {
      return;
    }

    const aplicaRetencion =
      typeof retencionActiva === "boolean" ? retencionActiva : checkedRete;

    const serviciosAdicionalesFiltrados = serviciosParaCotizar
      .filter(
        (servicio) =>
          !serviceDisabled.includes(Number(servicio.id)) &&
          getNumeroSeguro(servicio.cant_predet) > 0
      )
      .map((servicio) => ({
        id: Number(servicio.id),
        cantidad: getNumeroSeguro(servicio.cant_predet)
      }));

    let payload;

    if (tipoEscritura === "2" || tipoEscritura === "3") {
      const compraVentaId = actosMap["1"];
      const hipotecaId = tipoEscritura === "2"
        ? actosMap["hipoteca_particulares"]
        : actosMap["hipoteca_entidades"];

      payload = {
        actos: [
          {
            acto_id: compraVentaId,
            cuantia: getNumeroSeguro(valorCuantia),
            aplica_retencion: aplicaRetencion,
            aplica_exentos: false,
            servicios_adicionales: serviciosAdicionalesFiltrados
          },
          {
            acto_id: hipotecaId,
            cuantia: getNumeroSeguro(valorHipoteca),
            aplica_retencion: aplicaRetencion,
            aplica_exentos: false,
            servicios_adicionales: []
          }
        ]
      };
    } else {
      const actoId = actosMap[tipoEscritura] || tipoEscritura;
      const cuantiaTotal = getNumeroSeguro(valorCuantia) + getNumeroSeguro(valorHipoteca);

      payload = {
        actos: [
          {
            acto_id: actoId,
            cuantia: cuantiaTotal,
            aplica_retencion: aplicaRetencion,
            aplica_exentos: false,
            servicios_adicionales: serviciosAdicionalesFiltrados
          }
        ]
      };
    }

    try {
      const respuesta = await onCotizar(payload);
      aplicarRespuestaCotizacion(respuesta);
    } catch (error) {
      console.error("Error al cotizar:", error.response?.data || error.message);
    }
  };

  const formatear = (num) => {
    while (num.toString().indexOf(".") !== -1) {
      num = num.toString().replace(".", "");
    }

    num = num.toString();
    let resultado = "";
    for (let j = 0, i = num.length - 1; i >= 0; i -= 1, j += 1) {
      resultado = num.charAt(i) + (j > 0 && j % 3 === 0 ? "." : "") + resultado;
    }

    return resultado;
  };

  const getDataUri = (url) =>
    new Promise((resolve) => {
      if (!url) {
        resolve(null);
        return;
      }

      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function onLoad() {
        const canvas = document.createElement("canvas");
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;

        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        canvas.getContext("2d").drawImage(this, 0, 0);

        resolve(canvas.toDataURL("image/jpeg"));
      };

      image.src = url;
    });

  const pdf = async () => {
    let vertical = 0;
    let horizontal = 0;
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "letter"
    });

    doc.setFontSize(16);
    doc.setFontType("bold");
    doc.text(notaria.nombre_notaria || "", 20, 25);
    doc.setFontSize(10);
    vertical = 30;
    horizontal = 20;
    doc.setFontType("normal");
    doc.text(notaria.notario || "", horizontal, vertical);
    doc.text(`Nit. ${notaria.identificacion || ""}`, horizontal, vertical + 5);
    doc.text(notaria.direccion || "", horizontal, vertical + 10);
    doc.text(notaria.telefono || "", horizontal, vertical + 15);
    doc.text(notaria.regimen || "", horizontal, vertical + 20);
    doc.line(horizontal, vertical + 23, 200, vertical + 23);
    doc.line(horizontal, vertical + 24, 200, vertical + 24);

    const urlLogo = await getDataUri(logoSrc);
    if (urlLogo) {
      doc.addImage(urlLogo, "JPEG", 130, 20, 60, 25);
    }

    vertical = 60;
    doc.setFontSize(16);
    doc.setFontType("bold");
    doc.text("Cotizacion Previa", 100, vertical);
    doc.setFontSize(12);
    doc.setFontType("normal");
    doc.text("Acto:", horizontal + 10, vertical + 10);
    doc.text(nombreActo, horizontal + 23, vertical + 10);
    const f = new Date();
    doc.text(
      `Fecha: ${f.getDate()}/${f.getMonth() + 1}/${f.getFullYear()}`,
      horizontal + 130,
      vertical + 10
    );

    if (showCuantia) {
      doc.text("Cuantia:", horizontal + 35, vertical + 20);
      doc.text(`$${formatear(valorCuantia)}`, horizontal + 55, vertical + 20);
    }

    if (showHipoteca) {
      doc.text("Hipoteca:", horizontal + 95, vertical + 20);
      doc.text(`$${formatear(valorHipoteca)}`, horizontal + 115, vertical + 20);
    }

    doc.setFontType("bold");
    vertical = 90;
    horizontal = 10;
    doc.text("Servicio", horizontal + 20, vertical);
    doc.text("Cantidad", horizontal + 80, vertical, "center");
    doc.text("Precio. Uni", horizontal + 110, vertical);
    doc.text("Total", horizontal + 156, vertical);

    doc.setFontType("normal");
    vertical = 100;
    horizontal = 30;
    if (actosDerechos.length > 0) {
      actosDerechos.forEach((derecho) => {
        // Truncar el nombre a 22 caracteres
        doc.text(derecho.nombre.slice(0, 22), horizontal, vertical);
        doc.text(String(derecho.cantidad), horizontal + 60, vertical);
        doc.text(`$${formatear(derecho.valor_unit)}`, horizontal + 110, vertical, "right");
        doc.text(
          `$${formatear(derecho.valor_unit * derecho.cantidad)}`,
          horizontal + 150,
          vertical,
          "right"
        );
        vertical += 5;
      });
      servicios.filter((s) => Number(s.id) !== 1).forEach((item) => {
        doc.text(item.servicio_name, horizontal, vertical);
        doc.text(String(item.cant_predet), horizontal + 60, vertical);
        doc.text(`$${formatear(item.valor_unit)}`, horizontal + 110, vertical, "right");
        doc.text(
          `$${formatear(item.valor_unit * item.cant_predet)}`,
          horizontal + 150,
          vertical,
          "right"
        );
        vertical += 5;
      });
    } else {
      servicios.forEach((item) => {
        doc.text(item.servicio_name, horizontal, vertical);
        doc.text(String(item.cant_predet), horizontal + 60, vertical);
        doc.text(`$${formatear(item.valor_unit)}`, horizontal + 110, vertical, "right");
        doc.text(
          `$${formatear(item.valor_unit * item.cant_predet)}`,
          horizontal + 150,
          vertical,
          "right"
        );
        vertical += 5;
      });
    }

    vertical += 10;
    doc.text("Iva:", horizontal + 110, vertical, "right");
    doc.text(`$${formatear(tIva)}`, horizontal + 150, vertical, "right");
    vertical += 5;
    doc.text("Super:", horizontal + 110, vertical, "right");
    doc.text(`$${formatear(tSuper)}`, horizontal + 150, vertical, "right");
    vertical += 5;
    doc.text("Fondo:", horizontal + 110, vertical, "right");
    doc.text(`$${formatear(tFondo)}`, horizontal + 150, vertical, "right");
    vertical += 5;

    if (checkedRete) {
      doc.text("Retencion:", horizontal + 110, vertical, "right");
      doc.text(`$${formatear(tRete)}`, horizontal + 150, vertical, "right");
      vertical += 5;
    }

    doc.setFontType("bold");
    doc.text("Gran Total:", horizontal + 110, vertical, "right");
    doc.text(`$${formatear(tCotizacion)}`, horizontal + 150, vertical, "right");

    vertical = 200;
    doc.line(20, vertical, 200, vertical);
    doc.setFontSize(10);
    doc.text("Generado por Sinfony", 85, vertical + 5);
    doc.save("Cotizacion.pdf");
  };

  return (
    <>
      <div id="cotizar" style={{ backgroundColor: "White", marginTop: "10em" }}>
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="12">
              <h1 className="text-center title" style={{ color: "#031425" }}>
                {title}<br />
              </h1>
              <div className="space-25"></div>
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto" lg="6">
              <Card style={{ borderRadius: "15px", border: "1px solid #888888" }}>
                <CardHeader style={{ borderBottom: "1px solid #888888" }}>
                  <h2 className="info-title text-center" style={{ marginTop: "10px" }}>
                    <b>Acto a cotizar</b>
                  </h2>
                </CardHeader>
                <CardBody style={{ marginBottom: "20px", padding: "20px 30px" }}>
                  <FormGroup>
                    <label htmlFor="Select1" style={{ fontWeight: "600", color: "#333", marginBottom: "10px", display: "block" }}>
                      Seleccionar tipo de acto:
                    </label>
                    <div style={{ position: "relative" }}>
                      <Input
                        id="Select1"
                        type="select"
                        value={tipoEscritura}
                        onChange={selectTipoEscritura}
                        style={{
                          height: "50px",
                          fontSize: "15px",
                          borderRadius: "10px",
                          border: "2px solid #ccc",
                          backgroundColor: "#fdfdfd",
                          color: tipoEscritura ? "#333" : "#999",
                          paddingLeft: "15px",
                          cursor: "pointer",
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 15px center",
                          backgroundSize: "16px",
                          transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
                        }}
                        onFocus={(e) => { e.target.style.borderColor = "#031425"; e.target.style.boxShadow = "0 0 0 3px rgba(3,20,37,0.15)"; }}
                        onBlur={(e) => { e.target.style.borderColor = "#ccc"; e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)"; }}
                      >
                        <option value="" disabled>
                          -- Elija el tipo de acto --
                        </option>
                        {selectOptions
                          .filter((opt) => opt.value !== "")
                          .map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                      </Input>
                    </div>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
            {showDerechos && (
              <Col className="ml-auto mr-auto" lg="6">
                <Card className="text-center" style={{ borderRadius: "15px", border: "1px solid #888888" }}>
                  <CardHeader>
                    <h4 className="info-title text-center" style={{ marginTop: "5px" }}>
                      Ingresar el valor:
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <Row className="justify-content-center">
                        {showCuantia && (
                          <Col sm="6">
                            <FormGroup>
                              <label><b>Cuantía</b></label>
                              <Input
                                id="valor_cuantia"
                                onChange={(e) => setValorCuantia(e.target.value)}
                                type="number"
                                value={valorCuantia}
                              />
                              <br />
                              <label className="text-center">
                                <b>Valor Cuantía: $ </b>{formatear(valorCuantia)}
                              </label>
                            </FormGroup>
                          </Col>
                        )}
                        {showHipoteca && (
                          <Col sm="6">
                            <FormGroup>
                              <label><b>Hipoteca</b></label>
                              <Input
                                id="valor_hipoteca"
                                onChange={(e) => setValorHipoteca(e.target.value)}
                                type="number"
                                value={valorHipoteca}
                              />
                              <br />
                              <label className="text-center">
                                <b>Valor Hipoteca: $ </b>{formatear(valorHipoteca)}
                              </label>
                            </FormGroup>
                          </Col>
                        )}
                      </Row>
                    </Form>
                      <Button onClick={() => cotizar()} color="info">
                        <b style={{ fontSize: "14px" }}>Cotizar</b>
                      </Button>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
          <Row>
            {showStatico && (
              <Col lg="12">
                <Card id="pdfdiv" style={{ borderRadius: "15px", border: "1px solid #888888" }}>
                  <CardHeader>
                    <h2 className="info-title text-center" style={{ marginTop: "20px" }}>
                      <b>Cotización</b>
                    </h2>
                  </CardHeader>
                  <CardBody>
                    <Table className="text-center" responsive>
                      <thead>
                        <tr>
                          <th style={{ color: "#1c6e38" }}>Servicios</th>
                          <th style={{ color: "#1c6e38" }}>Cantidad</th>
                          <th style={{ color: "#1c6e38" }}>Precio Unitario</th>
                          <th style={{ color: "#1c6e38" }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {actosDerechos.length > 0 && actosDerechos.map((derecho, idx) => (
                          <tr key={`derecho-acto-${idx}`}>
                            <td>{derecho.nombre}</td>
                            <td>
                              <Row className="justify-content-center">
                                <Col sm="6">
                                  <FormGroup>
                                    <Input
                                      disabled
                                      value={derecho.cantidad}
                                      type="number"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </td>
                            <td>{"$" + formatear(derecho.valor_unit)}</td>
                            <td>{"$" + formatear(derecho.valor_unit * derecho.cantidad)}</td>
                          </tr>
                        ))}
                        {(actosDerechos.length > 0
                          ? servicios.filter((s) => Number(s.id) !== 1)
                          : servicios
                        ).map((item) => (
                          <tr key={uuidv4()}>
                            <td>{item.servicio_name}</td>
                            <td>
                              <Row className="justify-content-center">
                                <Col sm="6">
                                  <FormGroup>
                                    <Input
                                      id={item.id.toString()}
                                      disabled={serviceDisabled.includes(item.id)}
                                      defaultValue={item.cant_predet}
                                      onChange={(e) => updateCantidad(e.target.id, e.target.value)}
                                      type="number"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </td>
                            <td>{"$" + formatear(item.valor_unit)}</td>
                            <td>{"$" + formatear(item.valor_unit * item.cant_predet)}</td>
                          </tr>
                        ))}
                        <tr>
                          <td></td>
                          <td></td>
                          <td>IVA</td>
                          <td>{"$" + formatear(tIva)}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>Super</td>
                          <td>{"$" + formatear(tSuper)}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>Fondo</td>
                          <td>{"$" + formatear(tFondo)}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td className="font-weight-normal">
                            <div className="custom-control custom-switch">
                              <input
                                checked={checkedRete}
                                type="checkbox"
                                className="custom-control-input"
                                id="customSwitch1"
                                onChange={(event) => checkedRetencion(event.target.checked)}
                              ></input>
                              <label className="custom-control-label" htmlFor="customSwitch1">
                                Retencion
                              </label>
                            </div>
                          </td>
                          <td>{checkedRete && "$" + formatear(tRete)}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>Total Cotización</td>
                          <td>{"$" + formatear(tCotizacion)}</td>
                        </tr>
                      </tbody>
                    </Table>
                    <Row>
                      <Col sm="12" className="text-center">
                        <h5 className="info-title text-center" style={{ marginTop: "10px" }}>
                          <b>Nota: </b>
                          <i>Retención <b>SI</b> para Persona Natural y <b>NO</b> para Persona Jurídica.</i>
                        </h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12" className="text-center">
                        <Button onClick={pdf} color="info">
                          <b style={{ fontSize: "14px" }}>Imprimir</b>
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CotizadorCore;
